import {request} from '@/helpers/apiClient'
import {PROMOTION_PRODUCT_SELECTION_CONFIG} from '@/utils/constants/apiConfig/Promotion/promotionProductSelectionConfig'

export const getPromotionDropdownValues = dropDownType =>
  request(PROMOTION_PRODUCT_SELECTION_CONFIG.PRODUCT_DROPDOWN_LIST(dropDownType))

export const getAllGTINs = queryParams => request(PROMOTION_PRODUCT_SELECTION_CONFIG.GTIN_ALL(queryParams))
export const getGTINDetails = (gtinId, queryParams) =>
  request(PROMOTION_PRODUCT_SELECTION_CONFIG.GTIN_DETAILS(gtinId, queryParams))
